import React from "react";
import data from "../data.json";
import tvIcon from "../images/icon-category-tv.svg";
import moviesIcon from "../images/icon-category-movie.svg";
import bookmarkIconOutline from "../images/icon-bookmark-empty.svg";
import bookmarkIconFill from "../images/icon-bookmark-full.svg";
import playIcon from "../images/icon-play.svg";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";

const Showcontent = ({ searchCategory, searchItem }) => {
	searchItem = searchItem.trim();
	const searchData = data;
	let searchWordFormatted;
	let searchResults = [];
	let searchResultsBookmarked = [];
	let searchResultsTrending = [];
	let searchResultsAll = [];
	const [bookmarkState, setBookmarkState] = React.useState(false);
	const [isShown, setIsShown] = React.useState(undefined);

	if (searchCategory === "home") {
		searchWordFormatted = true;
	}

	if (searchCategory === "movies") {
		searchWordFormatted = "Movie";
	}

	if (searchCategory === "tv series") {
		searchWordFormatted = "TV Series";
	}

	if (searchCategory === "bookmarked shows") {
		searchWordFormatted = "bookmarked";
	}

	for (let i = 0; i < searchData.length; i++) {
		if (searchData[i].isBookmarked === true) {
			searchResultsBookmarked.push(searchData[i]);
		}
		if (searchCategory === "home") {
			if (
				(searchWordFormatted === true && searchData[i].title.toLowerCase().includes(searchItem.toLowerCase())) ||
				(searchWordFormatted === true && searchData[i].year.toString().includes(searchItem.toLowerCase()))
			) {
				searchResultsAll.push(searchData[i]);
				if (searchData[i].isTrending === true) {
					searchResultsTrending.push(searchData[i]);
				} else {
					searchResults.push(searchData[i]);
				}
			}
		} else {
			if (searchCategory === "bookmarked shows") {
				if (
					(searchData[i].isBookmarked && searchData[i].title.toLowerCase().includes(searchItem.toLowerCase())) ||
					(searchData[i].isBookmarked && searchData[i].year.toString().includes(searchItem.toLowerCase()))
				) {
					searchResults.push(searchData[i]);
				}
			} else {
				if (
					(searchData[i].category === searchWordFormatted && searchData[i].title.toLowerCase().includes(searchItem.toLowerCase())) ||
					(searchData[i].category === searchWordFormatted && searchData[i].year.toString().includes(searchItem.toLowerCase()))
				) {
					searchResults.push(searchData[i]);
				}
			}
		}
	}

	const addBookmark = (result) => {
		result.isBookmarked = !result.isBookmarked;
		return setBookmarkState((prevBookmark) => !prevBookmark);
	};

	searchResultsTrending = searchResultsTrending.map((resultTrending) => {
		const imgSrc = `${resultTrending.thumbnail.regular.medium}`;
		return (
			<SwiperSlide
				onMouseEnter={() => (isShown === resultTrending.id ? setIsShown(undefined) : setIsShown(resultTrending.id))}
				onMouseLeave={() => (isShown === resultTrending.id ? setIsShown(undefined) : setIsShown(undefined))}
				className="card card-trending slide"
				key={`slide-${resultTrending.id}`}>
				<div className="img-tile-container" id={`trending ${resultTrending.id}`} style={{ backgroundImage: `url(${imgSrc})` }}>
					<div className={resultTrending.id === isShown ? "img-tile-overlay" : "img-tile"} style={{ height: "200px" }}>
						<div className="bookmark-icon-container">
							<img className="bookmark-icon" onClick={() => addBookmark(resultTrending)} src={resultTrending.isBookmarked ? bookmarkIconFill : bookmarkIconOutline} alt="Bookmark icon outline"></img>
						</div>
						{resultTrending.id === isShown ? (
							<div id={`video-hover-${resultTrending.id}`} className="hover-video-player">
								<img className="play-icon" src={playIcon} alt="Play Movie"></img>
								<h4>Play</h4>
							</div>
						) : null}
						<div style={{ alignSelf: "flex-start" }}>
							<div className="card-info-row">
								<p>{resultTrending.year}</p>
								<p>·</p>
								{resultTrending.category === "Movie" ? (
									<div className="card-info-row">
										<img src={moviesIcon} alt="Movie icon"></img> <p>{resultTrending.category}</p>
									</div>
								) : (
									<div className="card-info-row">
										<img src={tvIcon} alt="Tv show icon"></img> <p>{resultTrending.category}</p>
									</div>
								)}
								<p>·</p>
								<p>{resultTrending.rating}</p>
							</div>
							<h2 className="movie-title">{resultTrending.title}</h2>
						</div>
					</div>
				</div>
			</SwiperSlide>
		);
	});

	searchResultsAll = searchResultsAll.map((result) => {
		const imgSrc = `${result.thumbnail.regular.medium}`;
		return (
			<div
				onMouseEnter={() => (isShown === result.id ? setIsShown(undefined) : setIsShown(result.id))}
				onMouseLeave={() => (isShown === result.id ? setIsShown(undefined) : setIsShown(undefined))}
				className="card"
				key={result.id}>
				<div className="img-tile-container" id={result.id} style={{ backgroundImage: `url(${imgSrc})` }}>
					<div className={result.id === isShown ? "img-tile-overlay" : "img-tile"}>
						<div className="bookmark-icon-container">
							<img className="bookmark-icon" onClick={() => addBookmark(result)} src={result.isBookmarked ? bookmarkIconFill : bookmarkIconOutline} alt="Bookmark icon outline"></img>
						</div>
						{result.id === isShown ? (
							<div id={`video-hover-${result.id}`} className="hover-video-player">
								<img className="play-icon" src={playIcon} alt="Play Movie"></img>
								<h4>Play</h4>
							</div>
						) : null}
					</div>
				</div>
				<div className="card-info-row">
					<p>{result.year}</p>
					<p>·</p>
					{result.category === "Movie" ? (
						<div className="card-info-row">
							<img src={moviesIcon} alt="Movie icon"></img> <p>{result.category}</p>
						</div>
					) : (
						<div className="card-info-row">
							<img src={tvIcon} alt="Tv show icon"></img> <p>{result.category}</p>
						</div>
					)}
					<p>·</p>
					<p>{result.rating}</p>
				</div>
				<h2>{result.title}</h2>
			</div>
		);
	});

	searchResults = searchResults.map((result) => {
		const imgSrc = `${result.thumbnail.regular.medium}`;
		return (
			<div
				onMouseEnter={() => (isShown === result.id ? setIsShown(undefined) : setIsShown(result.id))}
				onMouseLeave={() => (isShown === result.id ? setIsShown(undefined) : setIsShown(undefined))}
				className="card"
				key={result.id}>
				<div className="img-tile-container" id={result.id} style={{ backgroundImage: `url(${imgSrc})` }}>
					<div className={result.id === isShown ? "img-tile-overlay" : "img-tile"}>
						<div className="bookmark-icon-container">
							<img className="bookmark-icon" onClick={() => addBookmark(result)} src={result.isBookmarked ? bookmarkIconFill : bookmarkIconOutline} alt="Bookmark icon outline"></img>
						</div>
						{result.id === isShown ? (
							<div id={`video-hover-${result.id}`} className="hover-video-player">
								<img className="play-icon" src={playIcon} alt="Play Movie"></img>
								<h4>Play</h4>
							</div>
						) : null}
					</div>
				</div>
				<div className="card-info-row">
					<p>{result.year}</p>
					<p>·</p>
					{result.category === "Movie" ? (
						<div className="card-info-row">
							<img src={moviesIcon} alt="Movie icon"></img> <p>{result.category}</p>
						</div>
					) : (
						<div className="card-info-row">
							<img src={tvIcon} alt="Tv show icon"></img> <p>{result.category}</p>
						</div>
					)}
					<p>·</p>
					<p>{result.rating}</p>
				</div>
				<h2>{result.title}</h2>
			</div>
		);
	});

	return (
		<div>
			{searchItem.length === 0 && searchCategory === "home" ? (
				<div>
					{searchCategory === "home" && <h2 className="title">Trending</h2>}
					<div className="swiper-container-div">
						<Swiper className="swiper" slidesPerView={"auto"} loop={true} spaceBetween={30} id="main-slider">
							{searchResultsTrending}
						</Swiper>
					</div>
				</div>
			) : null}

			{searchCategory === "home" && searchItem.length > 0 ? (
				<h2 className="title">{`Found ${searchResultsAll.length} ${searchResultsAll.length === 1 ? "result" : "results"} for '${searchItem}'`}</h2>
			) : searchCategory === "home" ? (
				<h2 className="title">Recommended For You</h2>
			) : null}
			{searchCategory === "movies" && searchItem.length > 0 ? (
				<h2 className="title">{`Found ${searchResults.length} ${searchResults.length === 1 ? "result" : "results"} for '${searchItem}'`}</h2>
			) : searchCategory === "movies" ? (
				<h2 className="title">Movies</h2>
			) : null}
			{searchCategory === "tv series" && searchItem.length > 0 ? (
				<h2 className="title">{`Found ${searchResults.length} ${searchResults.length === 1 ? "result" : "results"} for '${searchItem}'`}</h2>
			) : searchCategory === "tv series" ? (
				<h2 className="title">TV Series</h2>
			) : null}
			{searchCategory === "bookmarked shows" && searchItem.length > 0 ? (
				<h2 className="title">{`Found ${searchResults.length} ${searchResults.length === 1 ? "result" : "results"} for '${searchItem}'`}</h2>
			) : searchCategory === "bookmarked shows" ? (
				<h2 className="title">Bookmarked</h2>
			) : null}
			{searchCategory === "home" && searchItem.length > 0 ? <div className="results-grid">{searchResultsAll}</div> : <div className="results-grid">{searchResults}</div>}
		</div>
	);
};

export default Showcontent;
